import { Grid, List } from '@material-ui/core';
import React from 'react';
import Layout from './../../components/Layout';
import ChangePassword from './ChangePassword';

const Settings = () => {
    return (
        <Layout title="Ajustes">
            <List>
                <Grid container>
                    <Grid item xs={12} sm={6} md={4}>
                        <ChangePassword />
                    </Grid>
                </Grid>
            </List>
        </Layout>
    );
};

export default Settings;